import AppContext from 'App/AppContext';
import Task from 'models/tasks/task';
import { useContext, useEffect, useState } from 'react';
import { apiGetWebhooksForType } from 'services/Api/webhookService';
import { apiRequest } from 'services/Auth/authConfig';

//True when a new task was created from a template that has connected webhooks (which start a
//workflow on save).
export const useTemplateHasWorkflows = (task: Task, onError: (err: unknown) => void): boolean => {
  const appContext = useContext(AppContext);
  const [result, setResult] = useState<{ templateId: number; hasWorkflows: boolean } | undefined>(undefined);
  const templateId = task.taskId === -1 ? task.templateId : undefined;

  useEffect(() => {
    if (!templateId || templateId === result?.templateId) return;

    const loadWebhooks = async () => {
      try {
        const accessToken = await appContext.getAccessToken(apiRequest.scopes);
        const webHooks = await apiGetWebhooksForType('task', templateId, accessToken);
        setResult({ templateId, hasWorkflows: webHooks.length > 0 });
      } catch (err) {
        onError(err);
      }
    };

    loadWebhooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId]);

  return !!templateId && result?.templateId === templateId && result.hasWorkflows;
};
